import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "auth-splash"
}
const _hoisted_2 = {
  key: 3,
  class: "app-shell"
}
const _hoisted_3 = { class: "nav-group" }
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = {
  key: 0,
  class: "nav-submenu"
}
const _hoisted_6 = { class: "nav-group" }
const _hoisted_7 = ["aria-expanded"]
const _hoisted_8 = {
  key: 0,
  class: "nav-submenu"
}
const _hoisted_9 = { class: "nav-group" }
const _hoisted_10 = ["aria-expanded"]
const _hoisted_11 = {
  key: 0,
  class: "nav-submenu"
}
const _hoisted_12 = { class: "topbar" }
const _hoisted_13 = { class: "topbar-actions" }
const _hoisted_14 = { class: "date-pill" }
const _hoisted_15 = { class: "user-identity" }
const _hoisted_16 = { class: "avatar" }

import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import LoginView from "@/Domain/Authentication/LoginView.vue";
import ToastContainer from "@/Shared/components/ToastContainer.vue";
import {
  authenticationLoading,
  currentUser,
  initializeAuthentication,
  logout,
} from "@/Shared/services/authService";

type NavigationGroup = "cotisation" | "project" | "attendance";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const menuOpen = ref(false);
const cotisationNavigation = [
  { to: "/", label: "Vue d’ensemble", icon: "bi bi-grid-1x2" },
  {
    to: "/cotisations",
    label: "Gestion des cotisations",
    icon: "bi bi-cash-coin",
  },
  { to: "/membres", label: "Membres", icon: "bi bi-people" },
  { to: "/finances", label: "Bilans & sorties", icon: "bi bi-bar-chart" },
  {
    to: "/bilan-mensuel",
    label: "Bilan par mois",
    icon: "bi bi-calendar3-range",
  },
  { to: "/bilan-personnes", label: "Bilan par personne", icon: "bi bi-table" },
  { to: "/analyse", label: "Analyse", icon: "bi bi-graph-up-arrow" },
  { to: "/mois", label: "Gestion des mois", icon: "bi bi-calendar2-week" },
  { to: "/rappels", label: "Rappels WhatsApp", icon: "bi bi-whatsapp" },
  {
    to: "/rappel-action-sociale",
    label: "Rappel action sociale",
    icon: "bi bi-heart-pulse",
  },
];
const mainNavigation = [
  {
    to: "/cotisations-ponctuelles",
    label: "Cotisation ponctuelle",
    icon: "bi bi-calendar2-plus",
  },
  { to: "/utilisateurs", label: "Utilisateurs", icon: "bi bi-person-lock" },
  { to: "/parametres", label: "Paramètres", icon: "bi bi-sliders2" },
];
const projectNavigation = [
  { to: "/projets", label: "Vue projets", icon: "bi bi-grid" },
  { to: "/projets/dara", label: "Dara", icon: "bi bi-journal-bookmark" },
  {
    to: "/projets/vente-viande",
    label: "Vente de viande",
    icon: "bi bi-basket",
  },
];
const attendanceNavigation = [
  { to: "/presences/analyse", label: "Analyse et suivi", icon: "bi bi-graph-up" },
  { to: "/presences/suivi", label: "Suivi des présences", icon: "bi bi-calendar-check" },
  { to: "/presences/membres", label: "Membres présence", icon: "bi bi-people" },
  { to: "/presences/rappels", label: "Rappels WhatsApp", icon: "bi bi-whatsapp" },
  { to: "/presences/qr-code", label: "QR code présence", icon: "bi bi-qr-code" },
];
const cotisationPaths = cotisationNavigation.map((item) => item.to);
const projectPaths = projectNavigation.map((item) => item.to);
const attendancePaths = attendanceNavigation.map((item) => item.to);
const isCotisationRoute = computed(() =>
  cotisationPaths.includes(route.path)
);
const isProjectRoute = computed(() => projectPaths.includes(route.path));
const isAttendanceRoute = computed(() => attendancePaths.includes(route.path));
const isPublicRoute = computed(() => Boolean(route.meta.public));
const cotisationOpen = ref(isCotisationRoute.value);
const projectOpen = ref(isProjectRoute.value);
const attendanceOpen = ref(isAttendanceRoute.value);
const currentTitle = computed(() =>
  String(route.meta.title || "Vue d’ensemble")
);
const userInitials = computed(() =>
  currentUser.value
    ? `${currentUser.value.firstName[0] || ""}${
        currentUser.value.lastName[0] || ""
      }`.toUpperCase()
    : ""
);
const currentDate = new Intl.DateTimeFormat("fr-FR", {
  day: "2-digit",
  month: "short",
  year: "numeric",
}).format(new Date());
async function signOut() {
  await logout();
}
function toggleNavigationGroup(group: NavigationGroup) {
  const shouldOpen =
    group === "cotisation"
      ? !cotisationOpen.value
      : group === "project"
      ? !projectOpen.value
      : !attendanceOpen.value;

  cotisationOpen.value = group === "cotisation" ? shouldOpen : false;
  projectOpen.value = group === "project" ? shouldOpen : false;
  attendanceOpen.value = group === "attendance" ? shouldOpen : false;
}
watch(
  () => route.path,
  () => {
    cotisationOpen.value = isCotisationRoute.value;
    projectOpen.value = isProjectRoute.value;
    attendanceOpen.value = isAttendanceRoute.value;
  }
);
onMounted(initializeAuthentication);

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(authenticationLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "loading-ring" }, null, -1),
          _createElementVNode("strong", null, "Ouverture de l’espace sécurisé…", -1)
        ])))
      : (isPublicRoute.value)
        ? (_openBlock(), _createBlock(_component_RouterView, { key: 1 }))
        : (!_unref(currentUser))
          ? (_openBlock(), _createBlock(LoginView, { key: 2 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("aside", {
                class: _normalizeClass(["sidebar", { open: menuOpen.value }])
              }, [
                _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"brand\" aria-label=\"Cotisation Section Lyon\"><div class=\"brand-monogram\" aria-hidden=\"true\"><span class=\"brand-letter brand-letter-c\">C</span><span class=\"brand-letter brand-letter-s\">S</span><span class=\"brand-letter brand-letter-l\">L</span></div><strong>Section Lyon</strong></div>", 1)),
                _createElementVNode("nav", null, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-group-button", { active: isCotisationRoute.value }]),
                      "aria-expanded": cotisationOpen.value,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleNavigationGroup('cotisation')))
                    }, [
                      _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-wallet2" }, null, -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("span", null, "Cotisation mensuelle", -1)),
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi nav-chevron", cotisationOpen.value ? 'bi-chevron-up' : 'bi-chevron-down'])
                      }, null, 2)
                    ], 10, _hoisted_4),
                    _createVNode(_Transition, { name: "nav-submenu" }, {
                      default: _withCtx(() => [
                        (cotisationOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cotisationNavigation, (item) => {
                                return _createVNode(_component_RouterLink, {
                                  key: item.to,
                                  to: item.to,
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (menuOpen.value = false))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(item.icon)
                                    }, null, 2),
                                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              }), 64))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-group-button", { active: isProjectRoute.value }]),
                      "aria-expanded": projectOpen.value,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleNavigationGroup('project')))
                    }, [
                      _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-collection" }, null, -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("span", null, "Projet", -1)),
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi nav-chevron", projectOpen.value ? 'bi-chevron-up' : 'bi-chevron-down'])
                      }, null, 2)
                    ], 10, _hoisted_7),
                    _createVNode(_Transition, { name: "nav-submenu" }, {
                      default: _withCtx(() => [
                        (projectOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(projectNavigation, (item) => {
                                return _createVNode(_component_RouterLink, {
                                  key: item.to,
                                  to: item.to,
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (menuOpen.value = false))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(item.icon)
                                    }, null, 2),
                                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              }), 64))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-group-button", { active: isAttendanceRoute.value }]),
                      "aria-expanded": attendanceOpen.value,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleNavigationGroup('attendance')))
                    }, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-calendar-check" }, null, -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("span", null, "Liste de présence", -1)),
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi nav-chevron", attendanceOpen.value ? 'bi-chevron-up' : 'bi-chevron-down'])
                      }, null, 2)
                    ], 10, _hoisted_10),
                    _createVNode(_Transition, { name: "nav-submenu" }, {
                      default: _withCtx(() => [
                        (attendanceOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(attendanceNavigation, (item) => {
                                return _createVNode(_component_RouterLink, {
                                  key: item.to,
                                  to: item.to,
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (menuOpen.value = false))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(item.icon)
                                    }, null, 2),
                                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              }), 64))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mainNavigation, (item) => {
                    return _createVNode(_component_RouterLink, {
                      key: item.to,
                      to: item.to,
                      class: "nav-top-level",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (menuOpen.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(item.icon)
                        }, null, 2),
                        _createElementVNode("span", null, _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  }), 64))
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "sidebar-footer" }, [
                  _createElementVNode("span", { class: "status-dot" }),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, "Données sécurisées"),
                    _createElementVNode("small", null, "Sauvegarde locale")
                  ])
                ], -1))
              ], 2),
              _createElementVNode("main", null, [
                _createElementVNode("header", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "icon-button mobile-menu",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (menuOpen.value = !menuOpen.value))
                  }, _cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "bi bi-list" }, null, -1)
                  ])),
                  _createElementVNode("div", null, [
                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "eyebrow" }, "Espace trésorerie", -1)),
                    _createElementVNode("h1", null, _toDisplayString(currentTitle.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[20] || (_cache[20] = _createElementVNode("i", { class: "bi bi-calendar3" }, null, -1)),
                      _createTextVNode(_toDisplayString(_unref(currentDate)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(userInitials.value), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(_unref(currentUser).firstName), 1),
                        _createElementVNode("small", null, _toDisplayString(_unref(currentUser).identifier), 1)
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "icon-button logout-button",
                      title: "Se déconnecter",
                      onClick: signOut
                    }, _cache[21] || (_cache[21] = [
                      _createElementVNode("i", { class: "bi bi-box-arrow-right" }, null, -1)
                    ]))
                  ])
                ]),
                _createVNode(_component_RouterView)
              ]),
              (menuOpen.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "overlay",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (menuOpen.value = false))
                  }))
                : _createCommentVNode("", true)
            ])),
    _createVNode(ToastContainer)
  ], 64))
}
}

})